<div class="animated fadeIn trafficDetail w-full h-full p-6" id="stuff-to-print">
  <ng-template dynamicComponent></ng-template>
</div>
